import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SITE_URL, SITE_NAME, DEFAULT_OG_IMAGE, BUSINESS } from '../seo/siteConfig';

/**
 * LocalBusiness structured data (JSON-LD) for AM Facilities.
 * Rendered once (on the home page) so search engines understand the local
 * service business, its service area, contact info and social profiles.
 */
export default function LocalBusinessJsonLd() {
  const data = {
    '@context': 'https://schema.org',
    '@type': 'HomeAndConstructionBusiness',
    '@id': `${SITE_URL}/#business`,
    name: SITE_NAME,
    legalName: BUSINESS.legalName,
    url: SITE_URL,
    logo: DEFAULT_OG_IMAGE,
    image: DEFAULT_OG_IMAGE,
    telephone: BUSINESS.telephone,
    email: BUSINESS.email,
    founder: { '@type': 'Person', name: BUSINESS.founder },
    areaServed: BUSINESS.areaServed.map((name) => ({ '@type': 'AdministrativeArea', name })),
    address: {
      '@type': 'PostalAddress',
      addressRegion: 'ON',
      addressCountry: 'CA',
    },
    sameAs: BUSINESS.sameAs,
    priceRange: '$$',
    makesOffer: [
      'House Cleaning',
      'Condo Cleaning',
      'Office Cleaning',
      'Home Maintenance Inspection',
    ].map((name) => ({ '@type': 'Offer', itemOffered: { '@type': 'Service', name, areaServed: 'Greater Toronto Area' } })),
  };

  return (
    <Helmet>
      <script type='application/ld+json'>{JSON.stringify(data)}</script>
    </Helmet>
  );
}
